import { TodaysAppointmentCard } from "./appointments-rail.service";
import RailSection from "../RailSection";
import AppointmentCard from "./AppointmentCard";

/**
 * The Today's Appointments section of the rail.
 *
 * Scoped to the logged-in coach unconditionally, admin view included; the coach's
 * own local day and local times, the participant's timezone deliberately ignored;
 * a card survives until its END time (a 9:00 twenty-minute call is there at 9:19
 * and gone at 9:20), re-evaluated on the minute tick rather than on reload.
 */

export interface TodaysAppointmentsSectionProps {
	cards: TodaysAppointmentCard[];
	isLoading: boolean;
	isError: boolean;
}

const TodaysAppointmentsSection = ({
	cards,
	isLoading,
	isError,
}: TodaysAppointmentsSectionProps) => {
	return (
		<RailSection
			titleKey="HOME.RAIL.APPOINTMENTS.TITLE"
			isLoading={isLoading}
			isError={isError}
			isEmpty={cards.length === 0}
			errorMessageKey="HOME.RAIL.APPOINTMENTS.ERROR"
			emptyMessageKey="HOME.RAIL.APPOINTMENTS.EMPTY"
			testId="todays-appointments"
		>
			<ul className="appointment-cards">
				{cards.map((card) => (
					<AppointmentCard
						key={card.id}
						card={card}
					/>
				))}
			</ul>
		</RailSection>
	);
};

export default TodaysAppointmentsSection;
